import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { ConsentsAndAuthorizationsDocumentTemplateModal } from './ConsentsAndAuthorizationsDocumentTemplateModal';

type ConsentsAndAuthorizationsDocumentTemplateModalOpenerRenderProps = { openModal: VoidFunction };
type ConsentsAndAuthorizationsDocumentTemplateModalOpenerProps = {
   readonly children: (renderProps: ConsentsAndAuthorizationsDocumentTemplateModalOpenerRenderProps) => ReactElement;
   readonly patientId: number;
   readonly printTemplateName: string;
   readonly printTemplateId: number;
   readonly onApproveAndPrint: VoidFunction;
};

export const ConsentsAndAuthorizationsDocumentTemplateModalOpener = (
   props: ConsentsAndAuthorizationsDocumentTemplateModalOpenerProps
): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <ConsentsAndAuthorizationsDocumentTemplateModal
               onApproveAndPrint={props.onApproveAndPrint}
               onClose={closeModal}
               patientId={props.patientId}
               printTemplateName={props.printTemplateName}
               printTemplateId={props.printTemplateId}
            />
         ) : null}
      </>
   );
};
